import { memo } from 'react';
import { Box, Checkbox, FormControlLabel, TextField } from '@mui/material';
import { Divider } from 'components/material-ui-styles';
import { StyledSimpleCard, StyledDefaultPrimaryButton } from 'styles';
import {
  SERVICE_NAME_HELPER_TEXT,
  useRegisterNewServiceForm,
} from 'TenantModule/hooks/useRegisterNewServiceForm';

const RegisterNewServiceCard = () => {
  const {
    fields,
    onChange,
    onSubmit,
    isCreatingService,
    isSeedBucketRequired,
    isSourceSeedBucketRequired,
    isNameInvalid,
    isServiceNameInvalid,
  } = useRegisterNewServiceForm();

  return (
    <StyledSimpleCard>
      <h3>Register New Service</h3>
      <form onSubmit={onSubmit}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-evenly',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
            }}
          >
            <TextField
              label="Name"
              name="name"
              value={fields.name}
              onChange={onChange}
              variant="outlined"
              required
              disabled={isCreatingService}
              error={isNameInvalid}
              helperText={isNameInvalid ? SERVICE_NAME_HELPER_TEXT : undefined}
            />
            <TextField
              label="Service Name"
              name="serviceName"
              value={fields.serviceName}
              onChange={onChange}
              variant="outlined"
              required
              disabled={isCreatingService}
              error={isServiceNameInvalid}
              helperText={isServiceNameInvalid ? SERVICE_NAME_HELPER_TEXT : undefined}
            />
            <TextField
              label="Cloud Integration Name"
              name="cloudIntegrationName"
              value={fields.cloudIntegrationName}
              onChange={onChange}
              variant="outlined"
              disabled={isCreatingService}
            />
            <TextField
              label="On-Prem Integration Name"
              name="onPremIntegrationName"
              value={fields.onPremIntegrationName}
              onChange={onChange}
              variant="outlined"
              disabled={isCreatingService}
            />
            <TextField
              label="Service Display Name"
              name="serviceDisplayName"
              value={fields.serviceDisplayName}
              onChange={onChange}
              variant="outlined"
              required
              disabled={isCreatingService}
              helperText="Shown in the Service Name dropdown when registering to a tenant or realm"
            />
            <TextField
              label="On-Prem Integration Display Name"
              name="onPremIntegrationDisplayName"
              value={fields.onPremIntegrationDisplayName}
              onChange={onChange}
              variant="outlined"
              disabled={isCreatingService}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={fields.isIntegrationAgent}
                  onChange={onChange}
                  name="isIntegrationAgent"
                  color="primary"
                />
              }
              label="Is Integration Agent"
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={fields.requiredForSubscription}
                  onChange={onChange}
                  name="requiredForSubscription"
                  color="primary"
                />
              }
              label="Required For Subscription"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={fields.requiredForSandbox}
                  onChange={onChange}
                  name="requiredForSandbox"
                  color="primary"
                />
              }
              label="Required For Sandbox"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={fields.canBeSeeded}
                  onChange={onChange}
                  name="canBeSeeded"
                  color="primary"
                />
              }
              label="Can Be Seeded"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={fields.mustBeSeeded}
                  onChange={onChange}
                  name="mustBeSeeded"
                  color="primary"
                />
              }
              label="Must Be Seeded"
            />
            {isSeedBucketRequired && (
              <TextField
                label="Seed Bucket"
                name="seedBucket"
                value={fields.seedBucket}
                onChange={onChange}
                variant="outlined"
                required
                disabled={isCreatingService}
              />
            )}
            {isSourceSeedBucketRequired && (
              <TextField
                label="Source Seed Bucket"
                name="sourceSeedBucket"
                value={fields.sourceSeedBucket}
                onChange={onChange}
                variant="outlined"
                required
                disabled={isCreatingService}
              />
            )}
          </Box>
        </Box>
        <Divider sx={{ my: 6 }} />
        <StyledDefaultPrimaryButton type="submit" disabled={isCreatingService}>
          Submit
        </StyledDefaultPrimaryButton>
      </form>
    </StyledSimpleCard>
  );
};

export default memo(RegisterNewServiceCard);
